/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { RFCDate } from "../../types/rfcdate.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PaygBillingSummary = {
  /**
   * Exact estimated current-cycle total in USD through recorded_through
   */
  estimatedTotalUsd: string;
  /**
   * Exact durable customer-billable OpenRouter inference spend in USD through recorded_through
   */
  otherInferenceSpendUsd: string;
  /**
   * End of the live paid Stripe service period (exclusive)
   */
  periodEnd: Date;
  /**
   * Start of the live paid Stripe service period
   */
  periodStart: Date;
  /**
   * Most recent completed durable UTC spend day included in the estimate
   */
  recordedThrough?: RFCDate | undefined;
  /**
   * Exact estimated tokens-under-management cost in USD
   */
  tumCostUsd: string;
  /**
   * Tokens under management in the live paid service period
   */
  tumTokens: number;
  /**
   * Exact flat USD price per token under management
   */
  tumUnitPriceUsd: string;
};

/** @internal */
export const PaygBillingSummary$inboundSchema: z.ZodMiniType<
  PaygBillingSummary,
  unknown
> = z.pipe(
  z.object({
    estimated_total_usd: z.string(),
    other_inference_spend_usd: z.string(),
    period_end: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    period_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    recorded_through: z.optional(
      z.pipe(z.string(), z.transform(v => new RFCDate(v))),
    ),
    tum_cost_usd: z.string(),
    tum_tokens: z.int(),
    tum_unit_price_usd: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "estimated_total_usd": "estimatedTotalUsd",
      "other_inference_spend_usd": "otherInferenceSpendUsd",
      "period_end": "periodEnd",
      "period_start": "periodStart",
      "recorded_through": "recordedThrough",
      "tum_cost_usd": "tumCostUsd",
      "tum_tokens": "tumTokens",
      "tum_unit_price_usd": "tumUnitPriceUsd",
    });
  }),
);

export function paygBillingSummaryFromJSON(
  jsonString: string,
): SafeParseResult<PaygBillingSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PaygBillingSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PaygBillingSummary' from JSON`,
  );
}
